﻿import { IEditor } from "../interface/editor";
import { ValidatorError } from "../types/validator-error";
import { ValidatorFn } from "../types/validator-fn";
import { ValidatorParam } from "../interface/validator-param";
import { isValidatorDisabled } from "./is-validator-disabled";

export function emailValidator(param: ValidatorParam): ValidatorFn {
    return (editor: IEditor): ValidatorError | null => {
        if (isValidatorDisabled(param, editor)) {
            return null;
        }

        if (editor.value !== undefined && editor.value != null && editor.value !== '') {
            let message='Validate Failed';
            if(param.message) {
                message= param.message;
            }

            const reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/i;
            if (!(reg.test(editor.value))) {
                return { message: message };
            } else {
                return null;
            }
        } else {
            return null;
        }
    };
}